// @flow
import { Label as PrimaryLabel } from './primary'

export const Label = (props: any) => ({
  ...PrimaryLabel(props),
  color: `${props.$palette('white')}`,
})

export const ValueText = (props: any) => ({
  marginLeft: '10px',
  color: `${props.$palette('white')}`,
  fontWeight: 'bold',
  alignSelf: 'center',
})
